import type { EnsureQueryDataOptions, QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { CLINIC_INFO } from "@/shared/clinic-config";
import { ApiError, RedirectError } from "./api";

/** Título da aba no padrão "Tela · Clínica". */
export function pageHead(title?: string) {
  return { meta: [{ title: title ? `${title} · ${CLINIC_INFO.name}` : CLINIC_INFO.name }] };
}

/**
 * Carrega os dados da tela antes de mostrar (loader da rota). Redirect pedido
 * pelo servidor e falta de login viram navegação.
 */
export async function ensurePage<T, K extends readonly unknown[]>(
  qc: QueryClient,
  opts: EnsureQueryDataOptions<T, Error, T, K>,
): Promise<T> {
  try {
    return await qc.ensureQueryData(opts);
  } catch (err) {
    if (err instanceof RedirectError) throw redirect({ href: err.to });
    if (err instanceof ApiError && err.status === 401) {
      throw redirect({ to: "/entrar", search: { de: location.pathname } as never });
    }
    throw err;
  }
}
